/*
 * @Descripttion:
 * @version:
 * @Author: 苏
 * @email: 1373842098@qq.com
 * @Date: 2022-09-13 14:53:45
 * @LastEditors: linxi
 * @LastEditTime: 2025-06-25 10:34:15
 */
import { Button, Checkbox, Col, Collapse, Divider, Popover, Row } from 'antd'
import React, { ReactElement, useState } from 'react'
import { Label } from '../../../compnents/widgets/Label'
import { HistoryContent } from './historyContent'
import { HistoryTitle } from './historyTitle'
import styles from './TcmCases.module.css'
import {useSelector} from "react-redux";
import {selectSettings} from "../../user/setting/settingSlice";
import { Checks } from '../../../models/setting'
import { sum } from 'lodash'

type action = 'check' | 'active' | 'again'
interface HistoryPanelProps {
  historyList: any
  historyData: any
  tag?: any
  onChange: (v: string) => void
  onCopy: (copyRecipe: boolean, srcTreatmentId: string) => void
  lookMoreHistoryList?: (num?: any) => void
  CollapseActivekey: string
  changeAction: (action: action, v?: any) => void
  seeOtherDoctor: boolean
  reuseTreatmentId?: string
  toothRegistrationId?: string
  onLookFile?: (url?: any, fileName?: string) => void
}

export const HistoryPanel = ({
  historyList,
  historyData,
  tag,
  onChange,
  onCopy,
  lookMoreHistoryList,
  CollapseActivekey,
  changeAction,
  seeOtherDoctor,
  reuseTreatmentId,
  toothRegistrationId, // 口腔专业版
  onLookFile,
}: HistoryPanelProps): ReactElement => {
  const [text, setText] = useState<any>()

  const [fzblLoading, setfzblLoading] = useState(false)
  const [fzblcfLoading, setfzblcfLoading] = useState(false)

  const settings = useSelector(selectSettings)
  const lxbxsNewFlag = settings?.[105]?.includes('1102') //新版 各项流行病学史齐全

  const historyItemTwo = [
    {
      name: '主诉：',
      value: 'chiefComplaint',
      flag: 1,
    },
    {
      name: '现病史：',
      value: 'historyOfPresentIllness',
      flag: 4,
    },
      {
      name: '流行病史：',
      value: 'lxbsContent',
      flag: 2,
    },
    {
      name: '既往史：',
      value: 'pastMedicalHistory',
      flag: 4,
    },
    {
      name: '过敏史：',
      value: 'allergen',
      flag: 4,
    },
    {
      name: '舌象：',
      value: 'tonguePicture',
      flag: 1,
    },
    {
      name: '脉象：',
      value: 'pulseCondition',
      flag: 1,
    },
    {
      name: '辨证论治：',
      value: 'syndromeDifferentiation',
      flag: 2,
    },
    {
      name: '诊断：',
      value: tag == 'tooth' ? 'diseaseList' : 'disease',
      flag: 1,
    },
    {
      name: '个人史：',
      value: 'personalHistory',
      flag: 4,
    },
    {
      name: '家族史：',
      value: 'familyHistory',
      flag: 4,
    },
    {
      name: '疫苗接种史：',
      value: 'vaccineHistory',
      flag: 3,
    },
    {
      name: '月经史：',
      value: 'menstrualHistory',
      flag: 4,
    },
    {
      name: '婚育史：',
      value: 'maritalHistory',
      flag: 4,
    },
    {
      name: '体格检查：',
      value: 'tgjc',
      flag: 2,
    },
    {
      name: '口腔检查：',
      value: 'stomatologyToothList',
      flag: 2,
    },

    {
      name: '辅助检查：',
      value: tag == 'tooth' ? 'inspectionToothList' : 'inspectionCheck',
      flag: 2,
    },
    {
      name: '治疗计划：',
      value: 'treatmentToothList',
      flag: 2,
    },
    {
      name: '处置：',
      value: 'disposeToothList',
      flag: 1,
    },
    {
      name: '治疗意见：',
      value: 'treatmentConclusion',
      flag: 2,
    },
    {
      name: '影像：',
      value: 'filelist',
      flag: 1,
    },
  ]

  const { Panel } = Collapse

  const message = seeOtherDoctor
    ? '您没有接诊过该患者'
    : '该患者在本机构没有历史就诊记录'

  return (
    <>
      {/*{!toothRegistrationId && (*/}
      {/*  <>*/}
      {/*    <Label label='就诊历史' style={{ marginLeft: 20 }} />*/}
      {/*    <Divider />*/}
      {/*  </>*/}
      {/*)}*/}
      <Col
        style={{
          padding: 10,
        }}
      >
        <Checkbox
          checked={seeOtherDoctor}
          onChange={(e) => {
            changeAction('check', e.target.checked)
            const check: any = e.target.checked
            localStorage.setItem('historyPanelCheck', check)
          }}
        >
          不看其他医生
        </Checkbox>
      </Col>
      <Col className={styles.historyContainer}>
        {historyList?.length ? (
          <Collapse
            key={historyList[0]?.id}
            expandIconPosition='right'
            defaultActiveKey={historyList[0]?.id}
            accordion
            activeKey={CollapseActivekey}
            onChange={(v) => {
              changeAction('active', v as string)
              if (v && !historyData[v as string]) {
                onChange(v as string)
              }
            }}
          >
            {historyList.map((t: any) => {
              const historyDataItem = historyData[t.id]
              const payStatus = historyDataItem?.map((item: any) => item.payStatus)?.[0]

              return (
              <Panel
                header={
                  <HistoryTitle t={t} CollapseActivekey={CollapseActivekey} />
                }
                key={t.id}
                style={{
                  backgroundColor: CollapseActivekey == t.id ? '#FAFAFA' : '',
                }}
              >
                <Row
                  justify='space-between'
                  style={{
                    marginBottom: 10,
                  }}
                >
                  <Button
                    size='small'
                    type='primary'
                    ghost
                    loading={fzblcfLoading}
                    onClick={() => {
                      const fzcfjgSetting = settings?.[Checks.FZCFJG]
                      const fzcfjgOptions = fzcfjgSetting ? fzcfjgSetting.split(',') : []
                      if (fzcfjgOptions.length === 1) {
                        setfzblcfLoading(true)
                        onCopy(true, t.id)
                        setTimeout(() => {
                          setfzblcfLoading(false)
                        }, 2000)
                      } else {
                        onCopy(true, t.id)
                      }
                    }}
                  >
                    复制病历及处方
                  </Button>
                  <Button
                    loading={fzblLoading}
                    type='primary'
                    ghost
                    size='small'
                    onClick={() => {
                      setfzblLoading(true)
                      onCopy(false, t.id)
                      setTimeout(() => {
                        setfzblLoading(false)
                      }, 2000)
                    }}
                  >
                    复制病历
                  </Button>
                  <Button
                    size='small'
                    type='primary'
                    ghost
                    // type={reuseTreatmentId == t.id ? 'primary' : 'default'}
                    onClick={() => {
                      changeAction(
                        'again',
                        reuseTreatmentId == t.id ? '' : t.id
                      )
                    }}
                  >
                    复诊
                  </Button>
                </Row>
                {historyItemTwo.map((v) => {
                  // 如果是流行病学史且lxbxsNewFlag为false，则不显示
                  if (v.value === 'lxbsContent' && !lxbxsNewFlag) {
                    return ''
                  }

                  return (tag != 'tooth' && t[v.value]) || (tag === 'tooth' && 
                    t[v.value]?.[0] && ( typeof t[v.value][0] === 'string' ? t[v.value][0].indexOf("<span>#</span>") < 0 : true
                  )) ? (
                    <div className={styles.historyItem}>
                      <div
                        className={
                          v.flag == 1
                            ? styles.historyNoWarp
                            : v.flag == 3
                            ? styles.historyWarpWidth
                            : v.flag == 4
                            ? styles.historyWarpWidthThreeText
                            : styles.historyWarp
                        }
                      >
                        {v.name}
                      </div>
                      <div className={styles.rightContent}>
                        {tag === 'tooth' && v?.value == 'diseaseList' ? (
                          t?.diseaseList?.map((item: any) => {
                            return (
                              <div 
                                dangerouslySetInnerHTML={{ __html: item }} 
                                key={item}
                                className={styles.rightContentText} 
                              />
                            )
                          })
                        ) : tag === 'tooth' &&
                          v?.value == 'stomatologyToothList' ? (
                          t?.stomatologyToothList?.map((item: any) => {
                            return (
                              <div 
                                dangerouslySetInnerHTML={{ __html: item }} 
                                key={item}
                                className={styles.rightContentText} 
                              />
                            )
                          })
                        ) : tag === 'tooth' &&
                          v?.value == 'inspectionToothList' ? (
                          t?.inspectionToothList?.map((item: any) => {
                            return (
                              <div 
                                dangerouslySetInnerHTML={{ __html: item }} 
                                key={item}
                                className={styles.rightContentText} 
                              />
                            )
                          })
                        ) : tag === 'tooth' &&
                          v?.value == 'treatmentToothList' ? (
                          t?.treatmentToothList?.map((item: any) => {
                            return (
                              <div
                                dangerouslySetInnerHTML={{ __html: item }}
                                key={item}
                                className={styles.rightContentText}
                              />
                            )
                          })
                        ) : tag === 'tooth' &&
                          v?.value == 'disposeToothList' ? (
                          t?.disposeToothList?.map((item: any) => {
                            return (
                              <div 
                                dangerouslySetInnerHTML={{ __html: item }} 
                                key={item}
                                className={styles.rightContentText} 
                              />
                            )
                          })
                        ) : v.value === 'lxbsContent' ? (
                          <div>
                            {(() => {
                                if (t[v.value]!=null&&t[v.value]!='') {
                                    const lxbsData = JSON.parse(t[v.value])
                                    return lxbsData?.fullText || ''
                                }else {
                                    return ''
                                }
                            })()}
                          </div>                                                                  
                        ) : v.value === 'filelist' ? (
                          <div style={{ cursor: 'pointer' }}>
                            {t[v.value]?.map((item: any, index: number) => (
                              <div key={index}>
                                {item?.fileList?.map((file: any, fIdx: number) => (
                                  file?.data ? (
                                    <img 
                                      key={fIdx}
                                      style={{
                                        width: 30,
                                        height: 30,
                                        marginRight: 5
                                      }}
                                      src={`data:image/png;base64,${file?.data}`}
                                      alt={file?.fileName} 
                                      onClick={() => onLookFile?.(file?.fileLink, file?.fileName)}
                                    />
                                  ) : (
                                    <div style={{ color: '#027AFF' }}>
                                      <span onClick={() => onLookFile?.(file?.fileLink, file?.fileName)}>{file?.fileName}</span>
                                    </div>
                                  )
                                ))}
                              </div>
                            ))}
                          </div>
                        ) : (
                          <div>{t[v.value].split('#%#').join('，')}</div>
                        )}
                      </div>
                    </div>
                  ) : (
                    ''
                  )
                })}
                {historyData[t.id] &&
                  historyData[t.id].map((re: any, i: number) => (
                    <HistoryContent v={re} key={i} />
                  ))}
                <Row
                  justify='space-between'
                  style={{
                    marginTop: 5,
                    // color: '#666',
                    paddingTop: 10,
                    borderTop: '1px dashed #eeeeee'
                  }}
                >
                  <span>{t.createTime}</span>
                  <span style={{ fontWeight: 'bold' }}>
                    {payStatus == 0 ? '待收' : payStatus == 1 ? '已收' : payStatus == 2 ? '已退' : '-'}:￥
                    { historyDataItem ?
                      sum(historyDataItem
                        ?.map((v: any) => (v?.payStatus == 0 ? v?.unpaidAmount : v?.payStatus == 1 ? v?.paidAmount : v?.payStatus == 2 ? v?.refundAmount : 0)))
                        ?.toFixed(2) : '0.00'}
                  </span>
                </Row>
              </Panel>
              )
            })}
          </Collapse>
        ) : (
          <div
            className={styles.historyMessage}
            style={{
              fontStyle: 'oblique',
              color: '#999',
            }}
          >
            {message}
          </div>
        )}
      </Col>
      <Row
        style={{
          fontStyle: 'oblique',
          color: '#999',
          padding: '0 15px',
          marginTop: 3,
        }}
        justify='end'
      >
        <div
          style={{
            width: '100%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
           
          }}
        >
          <Popover
            content={
              <p>
                {text
                  ? text
                  : '默认展示近1年数据，如需查看近5年数据，请点击查看更多数据'}
              </p>
            }
            placement='bottom'
          >
            <span>
              {text
                ? text
                : '默认展示近1年数据，如需查看近5年数据，请点击'}
            </span>
          </Popover>
          {text ? (
            ''
          ) : (
            <a
              style={{ paddingLeft: '6px' }}
              onClick={() => {
                lookMoreHistoryList && lookMoreHistoryList(5)
                setText('仅展示近5年数据，如需更多请联系服务人员')
              }}
            >
              查看更多数据
            </a>
          )}
        </div>
      </Row>
    </>
  )
}
